import SeoMetadata from "../../seo-metadata/seo-metadata";
import { Link, useNavigate } from "react-router-dom";
import { Typography, Button, ConfigProvider } from "antd";
import "./not-found-page.css";
import LogoBlack from "../../static/LogoGT_black.svg";

const { Text } = Typography;

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <SeoMetadata title="Страница не найдена | General Trucks" description="Запрашиваемая страница не найдена." noindex />
      <ConfigProvider
        theme={{
          components: {
            Button: {
              colorPrimary: "#F67828",
              colorPrimaryHover: "#F67828",
              colorPrimaryActive: "#F67828",
            },
          },
        }}
      >
        <section className="not-found-page" aria-labelledby="not-found-title">
          <div className="not-found-page__inner">
            <Link
              className="not-found-page__logo-link"
              to="/"
              aria-label="На главную"
            >
              <img
                src={LogoBlack}
                alt="Логотип General Trucks"
                className="not-found-page__logo"
                loading="lazy"
              />
            </Link>

            <Text id="not-found-title" className="not-found-page__title">
              404
            </Text>
            <Text className="not-found-page__subtitle not-found-page__subtitle--desktop">
              Страница не найдена
            </Text>
            <Text className="not-found-page__subtitle not-found-page__subtitle--mobile">
              Этой страницы не существует
            </Text>
            <Text className="not-found-page__description">
              Ссылка , по которой вы хотели перейти, не существует.
              <br /> Возможно, в ней была допущена опечатка или запрашиваемая
              страница удалена
            </Text>

            <Button
              type="primary"
              className="go-to-main-button"
              onClick={() => navigate("/")}
            >
              перейти на главную страницу
            </Button>
          </div>
        </section>
      </ConfigProvider>
    </>
  );
};
export default NotFoundPage;
